import Chart from 'chart.js'

;(function ($) {
  /**
   * initializeBlock
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    15/4/19
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */

  const translateMonth = function(month) {
    let result = month

    switch(month) {
        case 'May':
            result = 'Maj'
            break
        case 'Oct':
            result = 'Okt'
            break
    }

    return result
  }

  const translateLabel = function(label) {
    const month = label.match(/May|Oct/g);

    if ( ! month ) 
        return label

    const translation = translateMonth( month[0] );
    return label.replace( month, translation, 'g' );
  }

  const initializeBlock = function () {
    const ctx = document.querySelectorAll('.fund-info-chart')

    if (ctx.length) {
      for (let index = 0; index < ctx.length; index++) {
        const element = ctx[index]
        const fixedElement = element.getContext('2d')

        const priceData = JSON.parse(element.dataset.prices)
        const prices = []
        const dates = []

        for (let index = 0; index < priceData.length; index++) {
          const element = priceData[index]
          prices.push(element[0])
          dates.push(element[1])
        }

        const lineChart = new Chart(fixedElement, {
          type: 'line',
          data: {
            labels: dates.reverse(),
            datasets: [{
              label: 'Value',
              data: prices.reverse(),
              backgroundColor: 'rgba(0, 255, 212, 0.1)',
              borderColor: 'rgb(0, 255, 212)',
              borderDash: [0,6],
              borderJoinStyle: 'round',
              borderCapStyle: 'round',
              borderWidth: 4,
              lineTension: 0,
              pointRadius: 0
            }],
          },
          options: {
            scales:{
              xAxes: [{
                  bounds: 'data',
                  type: 'time',
                  time: {
                      isoWeekday: true,
                      unit: 'week',
                      displayFormats: {
                        week: 'MMM DD'
                      },
                  },
                  display: true,
                  gridLines: {
                    drawBorder: true,
                    color: 'rgba(255, 255, 255, .05)',
                    zeroLineColor: 'rgba(255, 255, 255, .05)',
                    drawTicks: true,
                  },
                  ticks: {
                    padding: 10,
                    align: 'start',
                    callback: function( label, index, labels ) {
                      return translateLabel( label )
                    }
                  },
              }],
              yAxes: [{
                display: true,
                gridLines: {
                  color: 'rgba(255, 255, 255, .05)',
                  drawTicks: false,
                },
                ticks: {
                  padding: 10
                },
              }],
            },
            tooltips: {
              mode: 'index',
              intersect: false,
              xPadding: 15,
              yPadding: 10,
              enabled: true,
              caretSize: 6,
              borderWidth: 1,
              borderColor: 'rgb(0, 255, 212)',
              backgroundColor: 'rgb(14, 14, 14)',
              displayColors: false,
              callbacks: {
                title: function(data) {
                    return translateLabel(data[0].xLabel);
                },
                label: function (item, data) {
                  return item.yLabel + ' SEK';
                }
            }
            },
            layout: {
              padding: 0,
            },
            legend: {
              display: false
            }
          }
        })
      }
    }
  }

  // Initialize each block on page load (front end).
  $(document).ready(function () {
    initializeBlock()
  })

  // Initialize dynamic block preview (editor).
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=fund-info', initializeBlock)
  }
})(jQuery)
